import * as yup from 'yup';
import {
	Row,
	RenderConfig,
	TextInput,
	AssetUploadInputOnS3,
	ASSET_TYPE,
	IMAGE_TYPES,
	SelectInput,
	EMPTY_ARRAY,
	Column,
	ASSET_OPTIONS,
	OUTPUT_IMAGE_FORMAT_LABEL,
	IMAGE_RESIZING_WITDH_LABEL,
	IMAGE_RESIZING_HEIGHT_LABEL,
	CheckboxInput
} from 'commons-ui';

import {
	assetsTagDependencyResolver,
	assetsTagDependencyResolverEdit,
	customTagResolver,
	customTagResolverEdit
} from './formConfigHelper';

export const FORM_FIELD_KEYS = {
	ASSET_NAME: 'assetName',
	ASSET_TYPE: 'assetType',
	OUTPUT_IMAGE_FORMAT: 'outImageFormat',
	CUSTOM_RESOLUTION_WIDTH: 'customResolutionWidth',
	CUSTOM_RESOLUTION_HEIGHT: 'customResolutionHeight',
	CREATED_AT: 'createdAt',
	UPDATED_AT: 'updatedAt',
	IMAGE_URL: 'imageUrl',
	ASSET_TAG: 'assetTag',
	CUSTOM_TAG: 'customTag',
	IS_MULTIPLE: 'isMultiple'
};

export const validationSchema = yup.object().shape({
	assetName: yup.string().required('Asset name is a required field'),
	assetType: yup.string().required('Asset Type is a required field'),
	customTag: yup
		.string()
		.transform((value) => value.trim().toLowerCase().replace(/ /g, '-'))
		.optional(),
	imageUrl: yup.string().required('Image is a required field'),
	customResolutionWidth: yup.number().min(1, 'Custom Resolution Width should be atleast 1').optional(),
	customResolutionHeight: yup.number().min(1, 'Custom Resolution Width should be atleast 1').optional()
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.ASSET_NAME]: new RenderConfig()
		.setName('assetName')
		.setLabel('Asset Name')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.CREATED_AT]: new RenderConfig()
		.setName('createdAt')
		.setLabel('Created At')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss',
			required: false
		}),
	[FORM_FIELD_KEYS.UPDATED_AT]: new RenderConfig()
		.setName('updatedAt')
		.setLabel('Updated At')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss',
			required: false
		}),
	[FORM_FIELD_KEYS.ASSET_TYPE]: new RenderConfig()
		.setName('assetType')
		.setLabel('Asset Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: ASSET_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.OUTPUT_IMAGE_FORMAT]: new RenderConfig()
		.setName('outputImageFormat')
		.setLabel(OUTPUT_IMAGE_FORMAT_LABEL)
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: IMAGE_TYPES,
			required: false
		}),
	[FORM_FIELD_KEYS.CUSTOM_RESOLUTION_WIDTH]: new RenderConfig()
		.setName('customResolutionWidth')
		.setLabel(IMAGE_RESIZING_WITDH_LABEL)
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		}),
	[FORM_FIELD_KEYS.CUSTOM_RESOLUTION_HEIGHT]: new RenderConfig()
		.setName('customResolutionHeight')
		.setLabel(IMAGE_RESIZING_HEIGHT_LABEL)
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		}),
	[FORM_FIELD_KEYS.ASSET_TAG]: new RenderConfig()
		.setName('assetTag')
		.setLabel('Select Tag')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			options: [],
			dependencies: [FORM_FIELD_KEYS.ASSET_TYPE],
			required: true,
			dependencyResolver: assetsTagDependencyResolver
		}),
	[FORM_FIELD_KEYS.CUSTOM_TAG]: new RenderConfig()
		.setName('customTag')
		.setLabel('Add your Custom Tag')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			dependencies: [FORM_FIELD_KEYS.ASSET_TAG],
			dependencyResolver: customTagResolver
		}),
	[FORM_FIELD_KEYS.IMAGE_URL]: new RenderConfig()
		.setName('imageUrl')
		.setLabel('Upload Asset')
		.setRenderer(AssetUploadInputOnS3)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true,
			assetType: ASSET_TYPE.MISC_ASSET,
			usePresignedUrl: true,
			maxFileSizeMB: 10
		}),
	[FORM_FIELD_KEYS.IS_MULTIPLE]: new RenderConfig()
		.setName('isMultiple')
		.setLabel('Extract and Upload Zip Files individually')
		.setRenderer(CheckboxInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false
		})
};
export const VIEW_FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.ASSET_NAME]: new RenderConfig()
		.setName('assetName')
		.setLabel('Asset Name')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: false, edit: false, view: false }, required: true }),
	[FORM_FIELD_KEYS.CREATED_AT]: new RenderConfig()
		.setName('createdAt')
		.setLabel('Created At')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss',
			required: false
		}),
	[FORM_FIELD_KEYS.UPDATED_AT]: new RenderConfig()
		.setName('updatedAt')
		.setLabel('Updated At')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss',
			required: false
		}),
	[FORM_FIELD_KEYS.ASSET_TYPE]: new RenderConfig()
		.setName('assetType')
		.setLabel('Asset Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			options: ASSET_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.OUTPUT_IMAGE_FORMAT]: new RenderConfig()
		.setName('outputImageFormat')
		.setLabel(OUTPUT_IMAGE_FORMAT_LABEL)
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			options: IMAGE_TYPES,
			required: true
		}),
	[FORM_FIELD_KEYS.CUSTOM_RESOLUTION_WIDTH]: new RenderConfig()
		.setName('customResolutionWidth')
		.setLabel(IMAGE_RESIZING_WITDH_LABEL)
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false }
		}),
	[FORM_FIELD_KEYS.CUSTOM_RESOLUTION_HEIGHT]: new RenderConfig()
		.setName('customResolutionHeight')
		.setLabel(IMAGE_RESIZING_HEIGHT_LABEL)
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false }
		}),
	[FORM_FIELD_KEYS.ASSET_TAG]: new RenderConfig()
		.setName('assetTag')
		.setLabel('Select Tag')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			options: [],
			dependencies: [FORM_FIELD_KEYS.ASSET_TYPE],
			required: true,
			dependencyResolver: assetsTagDependencyResolverEdit
		}),
	[FORM_FIELD_KEYS.CUSTOM_TAG]: new RenderConfig()
		.setName('customTag')
		.setLabel('Add your Custom Tag')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			dependencies: [FORM_FIELD_KEYS.ASSET_TAG],
			dependencyResolver: customTagResolverEdit
		}),
	[FORM_FIELD_KEYS.IMAGE_URL]: new RenderConfig()
		.setName('imageUrl')
		.setLabel('Upload asset')
		.setRenderer(AssetUploadInputOnS3)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			required: true,
			assetType: ASSET_TYPE.MISC_ASSET,
			usePresignedUrl: true,
			maxFileSizeMB: 10
		}),
	[FORM_FIELD_KEYS.IS_MULTIPLE]: new RenderConfig()
		.setName('isMultiple')
		.setLabel('Extract and Upload Zip Content individually')
		.setRenderer(CheckboxInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			required: false
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.ASSET_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.ASSET_TYPE)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.CUSTOM_RESOLUTION_WIDTH)]),
		new Column([new Row(FORM_FIELD_KEYS.CUSTOM_RESOLUTION_HEIGHT)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.IMAGE_URL)]),
		new Column([new Row(FORM_FIELD_KEYS.OUTPUT_IMAGE_FORMAT)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.CREATED_AT)]),
		new Column([new Row(FORM_FIELD_KEYS.UPDATED_AT)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.ASSET_TAG)]), new Column([new Row(FORM_FIELD_KEYS.CUSTOM_TAG)])]),
	new Row(FORM_FIELD_KEYS.IS_MULTIPLE)
];
